import { ServerResponse, WithAuditDetails } from 'data/types'
import { AxiosError } from 'axios';
import { History } from 'history';
import { Dispatch, Action } from 'redux';
import { RootState } from 'data/root.reducers';
import { ThunkDispatch } from 'redux-thunk';
import * as api from './jurisdictionArea.api';
import { extractErrorMessage } from '../../utils';
import {
  GET_JURISDICTION_AREA_LIST,
  CREATE_JURISDICTION_AREA,
  DELETE_JURISDICTION_AREA,
  JurisdictionAreaActionTypes,
  JurisdictionArea,
  JurisdictionAreaGridData,
  GO_TO_JURISDICTION_AREA_LIST,
  SELECT_JURISDICTION_AREA,
  SelectJurisdictionAreaAction,
  DeleteJurisdictionAreaThunkAction,
  CreateJurisdictionAreaThunkAction,
  OPEN_JURISDICTION_AREA_CREATE_PAGE,
  CLOSE_JURISDICTION_AREA_CREATE_PAGE,
  OPEN_JURISDICTION_AREA_EDIT_PAGE,
  CLOSE_JURISDICTION_AREA_EDIT_PAGE,
  GO_TO_JURISDICTION_AREA_VIEW,
} from './jurisdictionArea.types';
import { JURISDICTION_AREA, MISCELLANEOUS, SYSTEM_CONFIGURATION_ROUTE } from '../../constants';
import { getSelectedJurisdictionArea } from './jurisdictionArea.selectors';

export function goToJurisdictionAreaList(history: History): (dispatch: Dispatch) => void {
  return (dispatch: Dispatch) => {
    dispatch({
      type: GO_TO_JURISDICTION_AREA_LIST,
    });

    history.push(`${SYSTEM_CONFIGURATION_ROUTE}${MISCELLANEOUS}${JURISDICTION_AREA}`);
  };
}

export function goToJurisdictionAreaCreate(history: History): (dispatch: Dispatch) => void {
  return (dispatch: Dispatch) => {
    dispatch({
      type: OPEN_JURISDICTION_AREA_CREATE_PAGE,
    });

    history.push(`${SYSTEM_CONFIGURATION_ROUTE}${MISCELLANEOUS}${JURISDICTION_AREA}/create`);
  };
}

export function closeJurisdictionAreaCreatePage(history: History): (dispatch: Dispatch) => void {
  return (dispatch: Dispatch) => {
    dispatch({
      type: CLOSE_JURISDICTION_AREA_CREATE_PAGE,
    });

    history.push(`${SYSTEM_CONFIGURATION_ROUTE}${MISCELLANEOUS}${JURISDICTION_AREA}`);
  };
}

export function goToJurisdictionAreaEdit(history: History): (dispatch: Dispatch) => void {
  return (dispatch: Dispatch) => {
    dispatch({
      type: OPEN_JURISDICTION_AREA_EDIT_PAGE,
    });

    history.push(`${SYSTEM_CONFIGURATION_ROUTE}${MISCELLANEOUS}${JURISDICTION_AREA}/edit`);
  };
}

export function goToJurisdictionAreaView(history: History): (dispatch: Dispatch) => void {
  return (dispatch: Dispatch) => {
    dispatch({
      type: GO_TO_JURISDICTION_AREA_VIEW,
    });

    history.push(`${SYSTEM_CONFIGURATION_ROUTE}${MISCELLANEOUS}${JURISDICTION_AREA}/view`);
  };
}

export function closeJurisdictionAreaEditPage(history: History): (dispatch: Dispatch) => void {
  return (dispatch: Dispatch) => {
    dispatch({
      type: CLOSE_JURISDICTION_AREA_EDIT_PAGE,
    });

    history.push(`${SYSTEM_CONFIGURATION_ROUTE}${MISCELLANEOUS}${JURISDICTION_AREA}`);
  };
}

export function getJurisdictionAreaList(
  deliveryFunctionId: string,
): JurisdictionAreaActionTypes {
  return {
    type: GET_JURISDICTION_AREA_LIST,
    payload: api.getJurisdictionAreaList(deliveryFunctionId),
  };
}

export function createJurisdictionArea(
  deliveryFunctionId: string,
  body: WithAuditDetails<Partial<JurisdictionArea>>,
): CreateJurisdictionAreaThunkAction {
  return async (dispatch: ThunkDispatch<RootState, unknown, Action<string>>) => {
    try {
      await dispatch({
        type: CREATE_JURISDICTION_AREA,
        payload: api.createJurisdictionArea(deliveryFunctionId, body),
      });
      return { areaName: body.data?.id }

    } catch (e) {
      const errorMessage = extractErrorMessage(e as AxiosError<ServerResponse<void>>);
    }
  };
}

export function deleteJurisdictionArea(
  deliveryFunctionId: string,
  id: string,
): DeleteJurisdictionAreaThunkAction {
  return async (dispatch: ThunkDispatch<RootState, unknown, Action<string>>, getState: () => RootState) => {
    const [selectedJurisdictionArea] = getSelectedJurisdictionArea(getState());

    try {
      await dispatch({
        type: DELETE_JURISDICTION_AREA,
        payload: api.deleteJurisdictionArea(deliveryFunctionId, id),
      });
      return { areaName: selectedJurisdictionArea?.SS8ID }

    } catch (e) {
      const errorMessage = extractErrorMessage(e as AxiosError<ServerResponse<void>>);
    }
  };
}

export function selectJurisdictionArea(
  collectionFunction: JurisdictionAreaGridData[],
): SelectJurisdictionAreaAction {
  return {
    type: SELECT_JURISDICTION_AREA,
    payload: collectionFunction,
  };
}
